import { BehaviorSubject, Subject } from "rxjs";
import { Line } from "../../models/shapes/Line";
import { Rectangle } from "../../models/shapes/Rectangle";
import { Circle } from "../../models/shapes/Circle";
import { SymLine } from "../../models/shapes/SymLine.js";
import { Vector } from "../../models/Vector";
import { AbstractFrame } from "../../models/frames/AbstractFrame";
import { Point } from "../../models/Point";
import { s } from "./settings";
import { NetworkInfo } from "../../models/NetworkInfo";
import { cnv } from "../../libs/canvas-text/src/shared/cnv";
import { getNetworkLoops } from "../../services/graph&network";
import { Block } from "../../models/shapes/Block";
import { ObjectTypes } from "../enums";
// import { Graph } from "@dagrejs/graphlib";
import { IObjectPropWindowCallType } from '../types'




import { Shape } from "../types";
import { getDisplayedShapes as getDisplayedShapesUtil, getSelectedShapes as getSelectedShapesUtil, getLinesIfSelected as getLinesIfSelectedUtil } from "../utils/shapeFilters";
import { GraphRouteManager } from "../../services/GraphRouteManager";
import { Branch } from "../../models/nets/Branch";



// ********* ЧТО ЭТО ЗА ОБЪЕКТ a *********
/**
 * Объект a нужен для общения разных частей программы между собой.
 * Все глобальные свойства собраны в этом объекте, нигде в других местах
 * глобальные данные не хранятся, по крайней мере не должны хранится - если
 * такое место найдено, нужно перенести эти данные в объект a.
 * Ещё данные из этого объекта в основном используются в потоке программы,
 * а не в классах.
 */

/**
 * Издатели mode$, shapes$, storedShapes$, selected$ главным образом предназначаются для компонентов Svelte.
 * Чтобы узнать, где они используются, можно выполнить поиск например shapes$.sub... - так можно
 * точно узнать, где это используется
 */


const a = {
  mode: "none",
  mode$: new Subject(),
  realScale: null,
  realScale$: new Subject(),
  shapes: [] as Shape[],

  storedShapes$: new Subject(),
  storedCommands$: new Subject(),
  storedAliases$: new Subject(),
  retrieveAlias$: new Subject(),
  cmReceived$: new Subject(),
  activeShapes: [] as Shape[],
  storedText$: new Subject(),
  selected: false,
  selected$: new Subject(),
  stamp$: new Subject(),

  // отображение окна поиска блоков
  showBlockSearch$: new Subject(),

  // диалоговые окна
  showAlertDialog$: new Subject(),
  showErrorDialog$: new Subject(),
  showInputBlockCollectionDialog$: new Subject(),
  addToBlockCollection$: new Subject(),

  // расчёты
  updateCalculations$: new Subject(),

  // тип объекта линии (или по-другому режим черчения)

  _drawingMode: null,
  get drawingMode() {
    return this._drawingMode;
  },
  set drawingMode(type) {
    this._drawingMode = type;
  },
  drawingMode$: new BehaviorSubject(ObjectTypes.line),

  isMouseDown: false,
  magnet: null,
  magnetPosition: null as Point | null,
  anglePosition: null,

  // *** операции черчения и трансформации
  clickMoveStart: null,
  clickCopyStart: null,
  clickRotateStart: null,
  clickMirrorStart: null,
  clickScaleStart1: null,
  clickScaleStart2: null,
  clickScaleBaseDistanceX: null,
  clickScaleBaseDistanceY: null,
  clickScaleBaseDistance: null,
  clickScaleShapeDistance: null,
  clickLineStart: null,
  clickRectangleStart: null,
  clickCircleStart: null,
  clickSquareStart: null,
  clickMoveRouteStart: null,
  clickCalcNetworksStart: null,
  clickCalcNetworkEnd: null,
  clickAssignCpoint1: null,
  clickAssignCpoint2: null,
  clickAssignCpoint3: null,

  start: null as Point | null,
  end: null as Point | null,

  // shapes
  /** */
  line: new Line(Point.ORIGIN, Point.ORIGIN, [1, 0, 0, 1], 2),
  symline: new SymLine(Point.ORIGIN, Point.ORIGIN, [1, 0, 0, 1]),
  circle: new Circle(Point.ORIGIN, 0, [1, 0, 0, 1], 2),
  rectangle: new Rectangle(Point.ORIGIN, Point.ORIGIN, Point.ORIGIN, Point.ORIGIN, 0, 0, [1, 0, 0, 1], 2),
  free: new Block([], s.blockColor, s.blockThickness),
  selectFrame: new AbstractFrame(Point.ORIGIN, Point.ORIGIN, [0, 1, 0, 1]),
  sigmaInstance: null,
  sigmaUpdate$: new Subject(),
  gman: new GraphRouteManager(),


  // zoom
  zl: null,
  zlc: 1,


  // pan
  pan: false,
  isPanning: false,
  pan_tx: null,
  pan_ty: null,
  pan_start_x: null,
  pan_start_y: null,
  pan_mat: null,

  // net
  preNetInfo: new NetworkInfo(null, null, null, null, null, null, null),
  branches: [] as Branch[], // хранит последнее обновление ветвей сети
  branches$: new Subject<Branch[]>(),

  // angle snap
  mag1: true,
  mag2: true,
  angle_snap: false,

  vertices: [] as number[],

  // ctrl
  ctrl: false,

  // ui settings
  updateUI$: new Subject(),
  isPrintAreaVisible: false,
  isStampPdfVisible: true,

  blockUI: false,

  // selection state for two-step selection
  selectionStep: 0, // 0 = no selection, 1 = single branch selected, 2 = entire network selected

  // дополнительные event listeners, которые добавляются в результате операций, например таких как 'guide'
  eventListeners: [] as Array<{ elem: unknown; type: string; func: unknown }>,


  commandsUI: {
    callNetworkInfoWindow$: new Subject<IObjectPropWindowCallType>(),
    focusFlowRateInput$: new Subject<IObjectPropWindowCallType>(),
    showElementInfo$: new BehaviorSubject<boolean>(false)
  },

  cpoints: {
    p1: null as Point | null,
    p2: null as Point | null,
  },
  cpointsMod: {
    p1: null as Point | null,
    p2: null as Point | null,
  },
  cpointsFinal: {
    p1: null as Point | null,
    p2: null as Point | null
  },
  cpointsClick: null as string | null,
  cpointsRotateMatrix: null as number[] | null,
  cpointsInitAngleDeg: null as number | null,
  cSeg1: null as Line | null,
  cSeg2: null as Line | null,
  cSegs: null as Line[] | null,

  /*
  * переменная используется при черчении отрезка, нужна для того,
  * чтобы добавлять узлы только в конце черчения отрезка (когда clickLineStart === true)
  *
  */

  startConnectedToAnotherSegment: false,
  endConnectedToAnotherSegment: false,
  startLastTouchedSegment: null as Line | null,
  endLastTouchedSegment: null as Line | null,

  // nodes
  graphs: [],
  graph$: new Subject(),

  currentInputField: null,
  userInputValue: null,
  joinedShapeId: null,
  mouse: null,

};

/**
 * В принципе здесь чтобы не путаться, можно при необходимости из каждой функции обращаться к коллекции a.shapes
 */

/**
 * Основная функция получения коллекции a.shapes.
 * Объекты guide нигде кроме magnets не участвуют - их нельзя перемещать, копировать итд и соответственно выбирать, а можно только создать и удалить все разом
 * поэтому как фигуры они здесь не возвращаются.
 * И со скрытыми объектами тоже никаких операций не производится, поэтому они тоже не возвращаются
 */
function getDisplayedShapes() {
  return getDisplayedShapesUtil(a.shapes);
}

function getHiddenShapes() {
  return a.shapes.filter(s => s.hidden === true);
}

function getashapes() {
  return a.shapes;
}

function setashapes(shapes: Shape[]) {
  a.shapes = shapes;
}

function addShapes(shapes: Shape | Shape[]) {
  if (Array.isArray(shapes)) {
    a.shapes = a.shapes.concat(shapes);
  } else {
    a.shapes.push(shapes);
  }
}

function getSelectedShapes() {
  return getSelectedShapesUtil(a.shapes);
}

function getLinesIfSelected() {
  return getLinesIfSelectedUtil(a.shapes);
}

function selectAllShapes() {
  getDisplayedShapes().forEach(s => s.isSelected = true);
}

function resetSelectedShapes() {
  getashapes().filter(s => s.isSelected).forEach(s => s.isSelected = false);
}

function resetSelectionStep() {
  a.selectionStep = 0;
}

/**
 * Обновляет ветви сети на основе текущих графов
 * Вызывается автоматически при изменении графов
 */
function updateBranchesFromGraphs() {
  // Получаем все элементы сети
  const allshapes = getashapes();
  const netElements = getNetElements();

  if (netElements.length === 0) {
    // Clear branchIds from all elements when no branches exist
    // Use allShapes instead of empty netElements array
    allshapes.forEach(elem => {
      if ((elem as any).net) {
        (elem as any).net.clearBranches();
      }
    });
    a.branches$.next([]);
    return;
  }

  // Получаем выбранные сегменты для определения петель
  const selectedSegments = netElements.filter(s => s.type === 'line') as Line[];
  
  // Получаем петли сети
  const loops = getNetworkLoops(selectedSegments, a.graphs, a.sigmaInstance);

  // Clear all branchIds before assigning new ones
  // This ensures branchIds are always in sync with current branch structure
  netElements.forEach(elem => {
    if ((elem as any).net) {
      (elem as any).net.clearBranches();
    }
  });
  
  // Вычисляем ветви
  const branches = a.gman.getNetworkBranches((loops as unknown as string[][]), netElements as any);

  // Note: Tee flow direction types and exhaust/supply types are assigned in performNetworkCalculations()
  // after flow rates are calculated. We don't assign them here to avoid overwriting values set during calculations.
  // If updateBranchesFromGraphs() is called before calculations, assignTeeTypeExhaustOrSupply() will still be
  // called in performNetworkCalculations() later. If called after calculations, we don't want to overwrite.
  
  // Log if we're about to publish branches that might have existing flowDirectionType values
  if (branches.length > 0) {
    const allTees = netElements.filter((el: any) => el.type === 'tee') as any[];
    if (allTees.length > 0) {
      const teesWithFlowTypes = allTees.filter((tee: any) => tee.flowDirectionType && tee.flowDirectionType.size > 0);
      if (teesWithFlowTypes.length > 0) {
        console.log(`[Tee Flow Directions] updateBranchesFromGraphs(): Preserving ${teesWithFlowTypes.length} tees with existing flowDirectionType values`);
      }
    }
  }
  
  // Обновляем ветви
  a.branches$.next(branches);
  
}

function displayHiddenShapes() {
  getHiddenShapes().forEach(s => s.hidden = false);
}

function hideSelectedShapes() {
  getSelectedShapes().forEach(s => {
    s.isSelected = false;
    s.hidden = true;
  });
}

function pushSelected() {
  a.selected$.next(getSelectedShapes());
}

function selectIfMouseInShapeBoundary(mouse: Point) {
  var isinSelectBoundary = getDisplayedShapes().filter(s => s.isinSelectBoundary(mouse));
  if (isinSelectBoundary.length) {
    isinSelectBoundary?.forEach(s => {
      s.isSelected = !s.isSelected;
    });
    return true;
  }
  return false;
}

function addToCurrentListeners(elem: unknown, type: string, func: unknown) {
  var obj = {
    elem: elem,
    type: type,
    func: func
  };
  a.eventListeners.push(obj);
}

function detachAllListeners() {


  a.eventListeners.forEach(o => {
    if (o.elem && typeof (o.elem as any).removeEventListener === 'function') {
      (o.elem as any).removeEventListener(o.type, o.func);
    }
  });
  a.eventListeners.length = 0;
}

function reset() {
  a.clickMoveStart = null;
  a.clickCopyStart = null;
  a.clickRotateStart = null;
  a.clickMirrorStart = null;

  a.magnetPosition = null;
  a.anglePosition = null;

  a.clickScaleStart1 = null;
  a.clickScaleStart2 = null;

  a.clickLineStart = null;
  a.clickRectangleStart = null;
  a.clickCircleStart = null;
  a.clickSquareStart = null;
  a.clickMoveRouteStart = null;

  a.currentInputField = null;
}

function resetCpoints() {
  a.cpoints.p1 = null;
  a.cpoints.p2 = null;
  a.cpointsMod.p1 = null;
  a.cpointsMod.p2 = null;
  a.cpointsFinal.p1 = null;
  a.cpointsFinal.p2 = null;
  a.cpointsClick = null;
  a.cpointsRotateMatrix = null;
}


function getMode() {
  return a.mode;
}

function setMode(mode: string) {
  a.mode = mode;

  a.mode$.next(mode);

  if (cnv.context) {
    setCursor(cnv.context.canvas, mode);
  }

}

function setCursor(canvas: HTMLCanvasElement, mode: string) {
  if (!canvas) return;
  if (["select", "boundary", "networkHeating"].includes(mode)) {
    canvas.style.cursor = "pointer";
  } else if (["break"].includes(mode)) {
    canvas.style.cursor = "cell";
  } else {
    canvas.style.cursor = "crosshair";
  }
}

export function setCpoint1(point: Point | null) {
  a.cpoints.p1 = point?.clone() ?? null;
}

export function setCpoint2(point: Point | null) {
  a.cpoints.p2 = point?.clone() ?? null;
}

export function setCpointMod1(point: Point | null) {
  a.cpointsMod.p1 = point?.clone() ?? null;
}

export function setCpointMod2(point: Point | null) {
  a.cpointsMod.p2 = point?.clone() ?? null;
}

export function setCpointFinal1(point: Point | null) {
  a.cpointsFinal.p1 = point?.clone() ?? null;
}

export function setCpointFinal2(point: Point | null) {
  a.cpointsFinal.p2 = point?.clone() ?? null;
}

export function setCpointClick(str: string) {
  a.cpointsClick = str;
}

export function setCpointInitAngleDeg(angleDeg: number) {
  a.cpointsInitAngleDeg = angleDeg;
}

export function setCseg1(seg: Line) {
  a.cSeg1 = seg.getClone();
}
export function setCseg2(seg: Line) {
  a.cSeg2 = seg.getClone();
}
export function segCsegs(segs: Line[]) {
  a.cSegs = segs;
}

export function assignAend(mouse:Point) {
  if (a.magnetPosition) {
    a.end = a.magnetPosition;
  } else if (a.anglePosition) {
    a.end = a.anglePosition;
  } else {
    a.end = mouse;
  }
  return a.end?.clone() ?? new Point(0, 0);
}

export function setLastTouchedSegment(segWithConnectedSide:Line) {

  if (!a.clickLineStart) {
    a.startLastTouchedSegment = segWithConnectedSide;
  }
  else {
    a.endLastTouchedSegment = segWithConnectedSide;
  }
}
export function getStartLastTouchedSegment() {
  return a.startLastTouchedSegment;
}

export function getEndLastTouchedSegment() {
  return a.endLastTouchedSegment;
}

export function getNetElements() {
  const elements = getashapes();
  const netElements = elements.filter((el): el is Shape => {
    return !(el instanceof Rectangle) && !(el instanceof Circle);
  });

  return netElements;
}

a.branches$.subscribe((branches: Branch[])=> {
  a.branches = branches;
})

// Автоматическое обновление ветвей при изменении графов
a.graph$.subscribe(() => {
  // Обновляем ветви при изменении графов
  updateBranchesFromGraphs();
})

export {
  a,
  getashapes,
  setashapes,
  resetSelectedShapes,
  resetSelectionStep,
  getSelectedShapes,
  selectAllShapes,
  displayHiddenShapes,
  getDisplayedShapes,
  hideSelectedShapes,
  pushSelected,
  selectIfMouseInShapeBoundary,
  addShapes,
  addToCurrentListeners,
  detachAllListeners,
  reset,
  getMode,
  setMode,
  resetCpoints,
  getLinesIfSelected,
  updateBranchesFromGraphs,
};